// extracted by mini-css-extract-plugin
export default {"container":"MatchOdds_container__gfhcu","oddsWrapper":"MatchOdds_oddsWrapper__y4bVK","oddsWrapperDark":"MatchOdds_oddsWrapperDark__tbOWN"};